/**
 * Research Literature API client
 * Handles literature discovery and PDF analysis
 */

import { apiClient } from './client'
import type { CitationPaper } from './citations'

export interface LiteratureDiscoveryRequest {
  query: string
  max_results?: number
  year_from?: number
  year_to?: number
  custom_instructions?: string
}

export interface LiteratureDiscoveryResponse {
  papers: CitationPaper[]
  query_count: number
  papers_retrieved: number
  success: boolean
}

export interface PDFAnalysisResponse {
  paper: CitationPaper
  success: boolean
  message?: string
}

class ResearchLiteratureAPI {
  /**
   * Discover literature based on a search query
   */
  async discoverLiterature(
    request: LiteratureDiscoveryRequest
  ): Promise<LiteratureDiscoveryResponse> {
    return await apiClient.post('/api/research/discover-literature', request)
  }

  /**
   * Analyze uploaded PDF and extract citation metadata
   */
  async analyzePDF(
    file: File
  ): Promise<PDFAnalysisResponse> {
    const formData = new FormData()
    formData.append('file', file)
    
    return await apiClient.post('/api/research/analyze-pdf', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }
}

export const researchLiteratureAPI = new ResearchLiteratureAPI()
export default researchLiteratureAPI

